import Vue from 'vue'

export default {
  getPresignedUrl (query, callback, errorHandler) {
    return Vue.http.get(`open/presigned-url?${query}`).then(callback, errorHandler)
  },
}
